import React from 'react';
import type { BulletListBlock } from '../../types';

export interface BulletListBlockViewProps {
  block: BulletListBlock;
}

export function BulletListBlockView({ block }: BulletListBlockViewProps): React.ReactElement {
  return (
    <ul data-testid="block-bullet_list" className="list-disc pl-4 space-y-0.5 text-[14px] font-normal text-text-primary">
      {block.items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}
